export default "__VITE_ASSET__COR$kYSp__"